<template>
<div>
  <b-card title="Job History" no-body>
    <b-card-header>
      <div class="d-flex">
        <div class="p-1">
          <h3>Manifest History</h3>
        </div>
        <div class="ml-auto p-1">
          <b-button-group size="sm">
            <b-button
              variant="success"
              @click="switchView('list')"
              class="img-icon img-icon-bullet-list"
              v-bind:class="{ 'active' : getToggleState !== 'card'  }">
            </b-button>
            <b-button
              variant="success"
              @click="switchView('card')"
              class="img-icon img-icon-drawer"
              v-bind:class="{ 'active' : getToggleState === 'card' }">
            </b-button>
          </b-button-group>
        </div>
        <div class="p-1">
          <b-input-group size="sm">
            <b-form-input
              v-model="filterSearch"
              v-on:keyup.enter="searchClicked"
              type="search"
              id="ManifestNameTagSearchInput"
              placeholder="Name Search"
            ></b-form-input>
          </b-input-group>
        </div>
        <div class="p-1">
          <b-button @click="searchClicked" size="sm" v-b-popover.hover.left="'Run Search Query'" variant="outline-primary">Search</b-button>
        </div>
      </div>
    </b-card-header>

    <!-- Card Body -->
    <b-card-body >
      <div v-if="!this.session.loadedFirstPage" class="text-center p-3"><b-spinner size="sm"></b-spinner></div>
      <div v-else>
        <div v-if="manifestList && manifestList.length > 0">
          <template v-if="getToggleState === 'card'">
            <manifest-card-view
              v-for="(manifest,idx) in manifestList"
              v-bind:key="idx"
              :manifest="manifest"
              :name="manifest.manifestName"
              :link="`/manifests/${manifest.manifestId}`" :date="manifest.dateCreated">
            </manifest-card-view>
          </template>
          <b-table
            id="manifest-search-table"
            responsive
            :items="manifestList"
            :fields="fields"
            v-else
          >
            <template v-slot:cell(manifestMedia)="row" >
              <manifest-media-wrapper :manifest="row.item" class="hw-fixed"></manifest-media-wrapper>
            </template>
            <template v-slot:cell(manifestName)="row" >
              <router-link :to="openManifest(row)">{{ row.item.manifestName}}</router-link>
            </template>
            <template v-slot:cell(dateCreated)="row" >
              <span> {{ $moment(row.item.dateCreated).calendar() }} </span>
            </template>
            <template v-slot:cell(actions)="row" >
              <add-manifest-to-cart :manifestId="row.item.manifestId"></add-manifest-to-cart>
            </template>
          </b-table>
        </div>
        <div v-else class="text-center p-3">
          No manifests associated with this project yet.
        </div>
      </div>
    </b-card-body>
    <!-- Card Footer -->
    <b-card-footer>
      <b-form-invalid-feedback :state="!errorMessage" class="text-center">
          {{errorMessage}}
      </b-form-invalid-feedback>
    </b-card-footer>
  </b-card>
</div>
</template>

<script>

import 'flatpickr/dist/flatpickr.css';
import { ManifestListSession } from '#/services/manifests';
import ManifestCardView from './Manifest/ManifestCardView.vue';
import ManifestMediaWrapper from './Manifest/ManifestMediaWrapper.vue';
import AddManifestToCart from '#/ui/Components/Manifest/AddManifestToCart.vue';

export default {
  components: {
    ManifestCardView,
    ManifestMediaWrapper,
    AddManifestToCart,
  },
  mounted() {
    window.addEventListener('scroll', this.scroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scroll);
  },
  data() {
    const cellClass = 'align-middle text-center';
    const accountId = this.$store.getters.activeAccountId;
    const projectId = this.$store.getters.activeProjectId;
    return {
      session: new ManifestListSession(accountId, projectId),
      searchTerm: null,
      filterSearch: null,
      fields: [
        {
          key: 'manifestMedia', label: 'Manifest Media', class: cellClass, thStyle: { width: '300px' },
        },
        { key: 'manifestName', label: 'Manifest Name', class: cellClass },
        // { key: 'manifestDescription', label: 'Manifest Description', class: cellClass },
        { key: 'dateCreated', label: 'Date Created', class: cellClass },
        { key: 'actions', label: 'Action', class: cellClass },
      ],
    };
  },
  created() {
    return this.loadPage();
  },
  computed: {
    errorMessage() {
      return this.session.errorMessage;
    },
    manifestList() {
      console.log(this.session.manifests);
      return this.session.manifests;
    },
    getToggleState() {
      return this.$store.getters['preferences/getToggleState'];
    },
  },
  methods: {
    switchView(viewType) {
      const request = viewType;
      return this.$store.dispatch('preferences/setToggleState', request).then((response) => {
        console.log('Changed toggle state ', response);
      }).catch((error) => {
        console.log('Change toggle state error', error.message);
      });
    },
    scroll() {
      if (this.session.loading) {
        return;
      }
      const bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
      if (bottomOfWindow) {
        this.session.loadPage();
      }
    },
    async loadPage() {
      return this.session.loadPage();
    },
    searchClicked() {
      // TODO: what happens if we run search in the middle of another page loading? Do we get jumbled results?
      this.session.resetPageData();
      this.loadPage();
    },
    openManifest(rowItem) {
      return `/manifests/${rowItem.item.manifestId}`;
      // this.$router.push(path);
    },
  },
};
</script>
<style scoped>

.flex-container {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-align-content: flex-start;
  -ms-flex-line-pack: start;
  align-content: flex-start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
}

.hw-fixed {
  max-width: 270px !important;
  text-align: center !important;
}

.fixedWidth {
  max-width: 300px !important;
}
</style>
